// extracted by mini-css-extract-plugin
module.exports = {"priceNote":"UpdatePriceModal_priceNote__30BIz","price":"UpdatePriceModal_price__1Hupb"};